import { useAtomValue } from "jotai";
import { httpStatusCode } from "../shared/atoms/KlasisAtoms";
import { HttpStatusCodes } from "../utils/axios";
import NotFoundBlock from "../components/NotFoundBlock";
import PageContent from "../parts/page-content/PageContent";

const ErrorPageWrapper: React.FC = ({ children }) => {
    const statusCode = useAtomValue(httpStatusCode);

    if (statusCode === HttpStatusCodes.NOT_FOUND)
        return (
            <PageContent>
                <NotFoundBlock />
            </PageContent>
        );

    return <>{children}</>;
};

export default ErrorPageWrapper;
